import { render, staticRenderFns } from "./TableBudgetOther.vue?vue&type=template&id=332980c8&scoped=true&"
import script from "./TableBudgetOther.vue?vue&type=script&lang=js&"
export * from "./TableBudgetOther.vue?vue&type=script&lang=js&"
import style0 from "./TableBudgetOther.vue?vue&type=style&index=0&id=332980c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332980c8",
  null
  
)

export default component.exports